import PropTypes from 'prop-types';
import React, { Component } from 'react';

class FactSheetContent extends Component {

  static propTypes = {
    summary: PropTypes.object.isRequired,
    whenSentences: PropTypes.string.isRequired,
    modelfootnote: PropTypes.string.isRequired,
    unnatural: PropTypes.string.isRequired,
    yr1: PropTypes.string.isRequired,
    statelong: PropTypes.string.isRequired,
    placename: PropTypes.string.isRequired,
  };

  render() {
    const { summary, whenSentences,
            modelfootnote, unnatural, yr1, statelong, placename } = this.props;

    const impacts = Object.values(summary).find(obj => obj.type === "impacts");
    if (!impacts) {
      return null;
    }
    return <div style={{display: "none"}}>
      {impacts.data.map(d =>
        <p key={d.name}>{d.name}</p>
      )}
      <p>{whenSentences}</p>
      {this.props.children}
      <p>{modelfootnote}</p>
      <p>{unnatural}</p>
      <p>{yr1}</p>
      <p>{statelong}</p>
      <p>{placename}</p>
      <p>meter</p>
      <p>meters</p>
      <p>foot</p>
      <p>feet</p>
    </div>
  }

}

export default FactSheetContent;
